import { Component, Input } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { ScopeOfWorkAttachment } from 'src/app/shared/models/database-models';
import { VendorDocument } from 'src/app/shared/models/database-models/ApprovingOfficerSummary.model';

@Component({
  selector: 'app-scope-of-work',
  templateUrl: './scope-of-work.component.html',
  styleUrls: ['./scope-of-work.component.scss'],
})
export class ScopeOfWorkComponent {
  @Input() title: string = '';
  @Input() dataAttachment: ScopeOfWorkAttachment[] | VendorDocument[] = [];
  @Input() isVendorDocument: boolean = false;
  @Input() imageUrl?: string;

  constructor(private backendService: BackendApiService) { }

  async downloadAttactment(attachment: ScopeOfWorkAttachment) {
    try {
      let data: any = await lastValueFrom(
        this.backendService.downloadAttachment(
          attachment.AttachmentId?.toString() as string
        )
      );
      const arrayBuffer: any = data.attachment.data;
      const int8Array = new Uint8Array(arrayBuffer);
      let blob = new Blob([int8Array], { type: `application/json` });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = attachment.FileName;
      a.click();
      window.URL.revokeObjectURL(a.href);
    } catch (e) {
      alert('error downloading');
    }
  }

  getTaggedVendorNames(attachment: ScopeOfWorkAttachment | VendorDocument): string {
    console.log('NIvetha', attachment)
    if (this.isVendorDocument && 'taggedVendorNames' in attachment) {
      return attachment.taggedVendorNames || '-';
    }
    return '-';
  }
}
